export enum AdMode {
    REAL = "real",
    BLOCKED = "blocked",
    PLACEHOLDER = "palceholder"
}